module.exports = __webpack_public_path__ + "img/img_pintu@2x.04ff7be1.png";